export const DEFAULT_MESSAGE_CREATED_CONDITION = [
  {
    attribute_key: 'message_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_CONDITION = [
  {
    attribute_key: 'browser_language',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_OTHER_CONDITION = [
  {
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

// The hold is the case the scheduled evaluator exists for, so it is what a travel rule
// opens on.
export const DEFAULT_TRAVEL_CONDITION = [
  {
    attribute_key: 'travel_hold_state',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

// The stage category is the only thing a case rule can say that survives the workflow it
// was written against: an admin who rebuilds a ticket type takes every stage id with them,
// while "waiting" still means waiting. So it is what a case rule opens on.
export const DEFAULT_SUPPORT_CASE_CONDITION = [
  {
    attribute_key: 'case_stage_category',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_ACTIONS = [
  {
    action_name: 'assign_agent',
    action_params: [],
  },
];

// Case rules default to the webhook action, so the generic `assign_agent` default is not one
// of the actions a case event offers.
export const DEFAULT_SUPPORT_CASE_ACTIONS = [
  {
    action_name: 'send_webhook_event',
    action_params: [],
  },
];

export const MESSAGE_CONDITION_VALUES = [
  {
    id: 'incoming',
    name: 'Incoming',
    i18nKey: 'INCOMING',
  },
  {
    id: 'outgoing',
    name: 'Outgoing',
    i18nKey: 'OUTGOING',
  },
];

export const PRIORITY_CONDITION_VALUES = [
  {
    id: 'nil',
    name: 'None',
    i18nKey: 'NONE',
  },
  {
    id: 'low',
    name: 'Low',
    i18nKey: 'LOW',
  },
  {
    id: 'medium',
    name: 'Medium',
    i18nKey: 'MEDIUM',
  },
  {
    id: 'high',
    name: 'High',
    i18nKey: 'HIGH',
  },
  {
    id: 'urgent',
    name: 'Urgent',
    i18nKey: 'URGENT',
  },
];

// CaseStage's own enum, in the order a ticket moves through it. The workspace names its
// stages whatever it likes; the category is the machine-readable meaning behind that name,
// which is what makes it the one stage condition a rule can rely on.
export const CASE_STAGE_CATEGORY_VALUES = [
  { id: 'submitted', i18nKey: 'SUBMITTED' },
  { id: 'in_progress', i18nKey: 'IN_PROGRESS' },
  { id: 'waiting', i18nKey: 'WAITING' },
  { id: 'resolved', i18nKey: 'RESOLVED' },
];

// Travel condition values. These mirror TravelTrip's own vocabulary - the enum for status
// and #hold_state for the hold - so a rule and the trip panel use the same words for the
// same thing. See docs/travelport/travel-in-automations-design.md.
export const TRAVEL_TRIP_STATUS_VALUES = [
  { id: 'enquiring', i18nKey: 'ENQUIRING' },
  { id: 'quoted', i18nKey: 'QUOTED' },
  { id: 'held', i18nKey: 'HELD' },
  { id: 'booked', i18nKey: 'BOOKED' },
  { id: 'ticketed', i18nKey: 'TICKETED' },
  { id: 'closed', i18nKey: 'CLOSED' },
];

// `unknown` is deliberately offered alongside the rest: a held trip with no recorded
// deadline is a real state and a different claim from "there is no deadline to worry
// about".
export const TRAVEL_HOLD_STATE_VALUES = [
  { id: 'none', i18nKey: 'NONE' },
  { id: 'unknown', i18nKey: 'UNKNOWN' },
  { id: 'active', i18nKey: 'ACTIVE' },
  { id: 'expiring', i18nKey: 'EXPIRING' },
  { id: 'expired', i18nKey: 'EXPIRED' },
];
